export const FETCH_FINANCIALS_REQUEST = "FETCH_FINANCIALS_REQUEST";
export const FETCH_FINANCIALS_SUCCESS = "FETCH_FINANCIALS_SUCCESS";
export const FETCH_FINANCIALS_FAILURE = "FETCH_FINANCIALS_FAILURE";


